import * as yup from 'yup';
import * as formSchemaUtils from './formSchemaUtils';
import { VALUE_IS_REQUIRED } from './formSchemaUtils';
import { VALUE_MUST_BE_VALID_EDMS_NUMBER } from './formSchemaUtils';

export const getChemicalRiskAttributesObjectSchema = () =>
  yup.object().shape({
    boilingPoint: yup
      .mixed()
      .when(['chemicalProductStateId', 'hasChemRiskCalculation'], {
        is: (chemicalProductStateId, hasChemRiskCalculation) =>
          chemicalProductStateId === 2 && hasChemRiskCalculation, //LIQUID
        then: yup.mixed().mixedCustomRequired().nullable(),
      })
      .nullable(),
    operatingTemperature: yup
      .mixed()
      .when(['chemicalProductStateId', 'hasChemRiskCalculation'], {
        is: (chemicalProductStateId, hasChemRiskCalculation) =>
          chemicalProductStateId === 2 && hasChemRiskCalculation, //LIQUID
        then: yup.mixed().mixedCustomRequired().nullable(),
      })
      .nullable(),
    dustTendency: yup.object().when(['chemicalProductStateId', 'hasChemRiskCalculation'], {
      is: (chemicalProductStateId, hasChemRiskCalculation) => {
        return chemicalProductStateId == 3 && hasChemRiskCalculation;
      }, //SOLID
      then: formSchemaUtils.objectWithIdRequired().required(VALUE_IS_REQUIRED).nullable(),
      otherwise: yup.object().nullable(),
    }),
    ppmWorkInstrRef: yup
      .string()
      .max(18, formSchemaUtils.EXCEEDS_EDM_NUMBER_SIZE)
      .requiredIfRefHasValue(yup.ref('ppmIsWorkInstrProcRequired'))
      .matches(/^(\s*|\d+)$/, VALUE_MUST_BE_VALID_EDMS_NUMBER)
      .nullable(),
    ppmOtherRef: yup
      .string()
      .max(18, formSchemaUtils.EXCEEDS_EDM_NUMBER_SIZE)
      .requiredIfRefHasValue(yup.ref('ppmIsOtherRequired'))
      .matches(/^(\s*|\d+)$/, VALUE_MUST_BE_VALID_EDMS_NUMBER)
      .nullable(),
    ppeMaskRespiratorRef: yup
      .object()
      .when('ppeIsMaskRespiratorRequired', {
        is: true,
        then: formSchemaUtils.objectWithIdRequired().required(VALUE_IS_REQUIRED).nullable(),
      })
      .nullable(),
    ppeGlovesRef: yup
      .object()
      .when('ppeIsGlovesRequired', {
        is: true,
        then: formSchemaUtils.objectWithIdRequired().required(VALUE_IS_REQUIRED).nullable(),
      })
      .nullable(),
    ppeOtherRef: yup.string().requiredIfRefHasValue(yup.ref('ppeIsOtherRequired')).nullable(),
    edmsNumbersExposureMonitoring: yup
      .array()
      .of(
        yup
          .object()
          .shape({
            edmsNumber: yup
              .string()
              .matches(/^(\s*|\d+)$/, formSchemaUtils.VALUE_MUST_BE_VALID_EDMS_NUMBER)
              .max(18, formSchemaUtils.EXCEEDS_EDM_NUMBER_SIZE)
              .nullable(),
          })
          .nullable()
      )
      .nullable(),
    checkCseUser: yup.object().requiredIfRefHasValue(yup.ref('checkCseDte')).nullable(),
    checkCseDte: yup
      .object()
      .requiredIfRefHasValue(yup.ref('checkCseUser'))
      .isSameOrBeforeToday()
      .nullable(),
  });

export default getChemicalRiskAttributesObjectSchema;
